module.exports = __webpack_public_path__ + "static/img/icon6.b43619e0.svg";